export default __webpack_public_path__ + "0d1a9bebe7a8a42f3e07a1bfd624dbc0.png";